/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "../ColorsProvider";
import prefixStyles, { type StylesObject } from "../utils/prefixStyles";
import GlobalStyleSheet from "../GlobalStyleSheet";

const ANIMATION_LENGTH = 250;
const STYLE_ID = "nx-components_PartialCheckboxAnimation";

const stylesheet = `
  @keyframes ${STYLE_ID}_shrink-bounce {
    0% {
      transform: scale(1);
    }
    33% {
      transform: scale(0.85);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes ${STYLE_ID}_checkbox-check {
    0%{
      width: 0;
      height: 0;
      border-bottom: 3px solid white;
      transform: translate(0, 0);
    }
    100%{
      width: .5em;
      height: .5em;
      border-bottom: 3px solid white;
      transform: translate(-0.25em, -0.6em);
    }
  }
`;

GlobalStyleSheet.preload(STYLE_ID, stylesheet);

type Props = {
  checked?: ?boolean,
  style?: ?StylesObject,
  colors: ColorSet,
};

class PartialCheckbox extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    return nextProps.checked !== this.props.checked;
  }

  render() {
    const { checked, style, colors } = this.props;

    const styles = prefixStyles({
      wrapper: {
        position: "relative",
        fontSize: "24px",
        width: "1em",
        height: "1em",
        border: "2px solid currentColor",
        borderRadius: "2px",
        transition: `all ${ANIMATION_LENGTH}ms ease-out`,
      },
      checkedWrapper: {
        border: `0.5em solid ${colors.PRIMARY}`,
        animation: `${STYLE_ID}_shrink-bounce ${ANIMATION_LENGTH}ms ease-out`,
      },
      checkmark: {
        position: "absolute",
        transformOrigin: "bottom left",
        boxSizing: "content-box",
        borderBottom: "0px solid white", // border must be present for Safari to animate
        borderRight: "0px solid white",
        animation: `${STYLE_ID}_checkbox-check ${ANIMATION_LENGTH}ms 100ms ease-out forwards`,
      },
    });

    return (
      <div
        data-component-name="PartialCheckbox"
        data-component-prop-checked={String(checked)}
        style={{
          ...styles.wrapper,
          ...(checked ? styles.checkedWrapper : {}),
          ...style,
        }}
      >
        {checked ? <span style={styles.checkmark} /> : null}
      </div>
    );
  }
}

export default withColorsProvider(PartialCheckbox);



// WEBPACK FOOTER //
// ../nx-components/src/Pivot/PartialCheckbox.jsx